export default {
  create: function create(win, url, postData) {
    win.navigator.sendBeacon(url, JSON.stringify(postData));
  }
};